const maintenancesOutput = {
  title_scheduled: `Manutenções Agendadas`,
  title_pending: `Manutenções Pendentes`,
  title_progress: `Manutenções em Progresso`,
  title_expired: `Manutenções Em Atraso`,
  title_completed: `Manutenções Concluídas`,
  title_overdue: `Manutenções Vencidas`,
  title: 'Manutenções',
};

export default maintenancesOutput;
